import { post2 } from "@/shared/axios";
import { Jwt } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";

interface LoginAsCustomerResponse {
  username: number;
  group_item_id: number;
}

const useLoginAsCustomerMutation = () => {
  const mutation = useMutation<Jwt, any, LoginAsCustomerResponse>({
    mutationFn: (body: LoginAsCustomerResponse) =>
      post2(`/auth/login/as/customer`, body),
  });
  return mutation;
};

export default useLoginAsCustomerMutation;
